<script lang="ts" setup>
export interface TcSwitchProps {
  disabled?: boolean;
  modelValue: boolean;
}

const emit = defineEmits<{
  (event: "update:modelValue", value: boolean): void;
  (event: "change", value: boolean): void;
}>();

const props = withDefaults(defineProps<TcSwitchProps>(), { disabled: false });

const onChange = () => {
  if (props.disabled !== true) {
    const value = !props.modelValue;

    emit("update:modelValue", value);
    emit("change", value);
  }
};
</script>

<template>
  <div
    class="switch"
    :class="{
      'switch--unchecked': !modelValue,
      'switch--checked': modelValue,
      'switch--disabled': disabled === true,
    }"
    @click="onChange"
  >
    <div class="switch__toggle" />

    <input type="checkbox" v-if="modelValue" checked @click="onChange" />
    <input type="checkbox" v-else @click="onChange" />
  </div>
</template>

<style lang="scss">
.switch {
  border-radius: 100px;
  width: 40px;
  height: 24px;
  padding: 2px;
  position: relative;
  cursor: pointer;

  &--unchecked {
    @include colors.bg(content, mid);

    .switch__toggle {
      left: 2px;
      bottom: 2px;
    }
  }

  &--checked {
    @include colors.bg(content, high);

    .switch__toggle {
      left: 18px;
      bottom: 2px;
    }
  }

  &--disabled {
    opacity: 70%;
  }

  input[type="checkbox"] {
    display: none;
  }

  &__toggle {
    @include colors.bg(background, base);

    transition: left 0.3s ease-in-out;
    height: 20px;
    width: 20px;
    border-radius: 100%;
    position: absolute;
  }
}
</style>
